exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-disable:disabled,.flow-btn{text-align:center;border-radius:4px;background-color:#d06f6e;border:none;font-weight:400;font-size:16px;color:#fff}.btn-disable:disabled .icon-btn,.flow-btn .icon-btn{padding:0 5px}.btn-disable:hover:not(:disabled):disabled,.flow-btn:hover:not(:disabled){cursor:pointer}.btn-disable:active:disabled,.flow-btn:active{border:none;box-shadow:inset 0 0 10px rgba(0,0,0,.5)}.btn-disable:disabled,.flow-btn:disabled{background-color:hsla(1,51%,62%,.5);cursor:default}.btn-disable:focus:disabled,.flow-btn:focus{outline:none;border:none}.active-btn{background-color:#993d2e}", ""]);

// exports
